package com.anjuros.website.templates.template6.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.templates.selection.components.contactform.ContactForm
import com.anjuros.website.templates.selection.components.contactform.DROPDOWN_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.EMAIL_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.MESSAGE_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.NAME_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.PHONE_NUMBER_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.SuccessContactMessage
import com.anjuros.website.templates.selection.modules.Theme
import com.anjuros.website.templates.template6.modules.Template6Section
import com.anjuros.website.templates.template6.modules.Template6Theme
import com.anjuros.website.templates.template6.modules.getColor
import com.anjuros.website.templates.template6.modules.getColorOpacity
import com.anjuros.website.templates.template6.styles.Template6FormWidthStyle
import com.anjuros.website.templates.template6.util.ResKey
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun Template6ContactFormSection(modifier: Modifier) {
    Box(
        modifier = modifier
            .id(Template6Section.Contact.id)
        ,
        contentAlignment = Alignment.Center
    ) {

        Template6ContactBox(showBorder = false)

    }
}

@Composable
fun Template6ContactBox(
    modifier:Modifier = Template6FormWidthStyle.toModifier(),
    showBorder:Boolean
) {
    var success by remember { mutableStateOf(false) }


    Box(
        modifier =modifier
            .thenIf(!showBorder,Modifier.fillMaxWidth())
            .thenIf(showBorder,Modifier.margin(topBottom =50.px)
                .padding(30.px)
                .position(Position.Relative)
                .border(
                    width = 1.px,
                    color = Theme.DarkGrey.rgb,
                    style = LineStyle.Solid
                ).boxShadow(
                    2.px, 2.px, 5.0.px, 1.0.px, color = Theme.DarkGrey.rgb, false
                )
                .borderRadius(5.px))
        ,
        contentAlignment = Alignment.Center
    ) {


        ContactForm(
            isDemo = true,
            showLabel = false,
            buttonColor = Template6Theme.Secondary.getColor(),
            spamProtectionBackgroundColor = Template6Theme.OpacityPrimary2.getColorOpacity(),
            spamProtectionColor = Colors.White,
            spamShieldColor = "#ffffff",
            contactItemsList = listOf(
                NAME_CONTACT_FORM.copy(index = 0),
                EMAIL_CONTACT_FORM.copy(index = 1),
                PHONE_NUMBER_CONTACT_FORM.copy(index = 2),
                DROPDOWN_CONTACT_FORM.copy(
                    placeholderText = ResKey.CONTACT_DROP1,
                    labelText = ResKey.CONTACT_DROP1_LABEL,
                    nameText = "Type of work",

                    optionList = listOf(
                        ResKey.TEMPLATE6_CONTACT_DROPDOWN2,
                        ResKey.TEMPLATE6_CONTACT_DROPDOWN3,
                        ResKey.TEMPLATE6_CONTACT_DROPDOWN4,
                        ResKey.TEMPLATE6_CONTACT_DROPDOWN5,
                        ResKey.TEMPLATE6_CONTACT_DROPDOWN6,
                        ResKey.TEMPLATE6_CONTACT_DROPDOWN7,
                        ResKey.TEMPLATE6_CONTACT_DROPDOWN8,
                        ResKey.TEMPLATE6_CONTACT_DROPDOWN9,
                        ResKey.TEMPLATE6_CONTACT_DROPDOWN10,
                        ResKey.TEMPLATE6_CONTACT_DROPDOWN11,
                        ResKey.TEMPLATE6_CONTACT_DROPDOWN12,
                        ResKey.TEMPLATE6_CONTACT_DROPDOWN13
                    ),
                    index = 3
                ),
                MESSAGE_CONTACT_FORM.copy(index = 4),
            )
        ) {
            success = true
        }
        SuccessContactMessage(
            isDemo = true,
            showSuccess = success,
            onClose = { success = false }
        )
    }
}